import { useEffect, useState, useMemo } from 'react';

export const useTypist = (sentences, opts = {}, key = '') => {
  // always an array
  const safe = useMemo(() => (Array.isArray(sentences) ? sentences : []), [sentences]);

  const optsMemo = useMemo(
    () => ({ typeSpeed: 90, deleteSpeed: 40, holdDelay: 1500, ...opts }),
    [opts]
  );

  const [idx, setIdx] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);

  // reset on key change
  useEffect(() => {
    setIdx(0);
    setText('');
    setDeleting(false);
  }, [key]);

  // main loop
  useEffect(() => {
    if (!safe.length) return;          // nothing to type
    const cur = safe[idx % safe.length];
    let t;

    if (!deleting && text === cur) {
      t = setTimeout(() => setDeleting(true), optsMemo.holdDelay);
    } else if (deleting && text === '') {
      t = setTimeout(() => {
        setDeleting(false);
        setIdx(i => i + 1);
      }, 500);
    } else {
      const spd = deleting ? optsMemo.deleteSpeed : optsMemo.typeSpeed;
      t = setTimeout(() => {
        setText(p =>
          deleting ? p.slice(0, -1) : cur.slice(0, p.length + 1)
        );
      }, spd);
    }
    return () => clearTimeout(t);
  }, [text, deleting, idx, safe, optsMemo, key]);

  return text;
};;
